import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface PulseData {
  value: number;
  bucket: string;
  delta_1d: number;
  avg_7d: number;
  avg_30d: number;
  distance_from_neutral: number;
  slope_7d: number;
  direction_7d: "rising" | "falling" | "flat";
  regime_duration: number;
  regime: string;
  watch: string;
  color: string;
  generated_at: string;
  stale?: boolean;
}

async function fetchPulse(): Promise<PulseData | null> {
  try {
    const { data, error } = await supabase.functions.invoke("fng-pulse");
    if (error) return null;
    if (data?.error) return null;
    return data as PulseData;
  } catch {
    return null;
  }
}

export function usePulse(enabled = true) {
  return useQuery({
    queryKey: ["fng-pulse"],
    queryFn: fetchPulse,
    staleTime: 15 * 60 * 1000, // 15 min — data is daily
    refetchOnWindowFocus: false,
    enabled,
    retry: false,
  });
}
